(function () {
var $12fa022bfe3847c5$exports = {};
// document.addEventListener("DOMContentLoaded", function () {
function $12fa022bfe3847c5$var$initializeSlider(selector, prevArrow, nextArrow, rtl = false) {
    const slider = $(selector);
    if (slider.length === 0) return; // Slider element not found, skip initialization
    const sliderOptions = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrow: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        rtl: rtl,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    arrow: true
                }
            }
        ]
    };
    slider.slick(sliderOptions);
}
const $12fa022bfe3847c5$var$prevArrow = $(".movePrev");
const $12fa022bfe3847c5$var$nextArrow = $(".moveNext");
const $12fa022bfe3847c5$var$prevArrowMt = $(".movePrev-mt");
const $12fa022bfe3847c5$var$nextArrowMt = $(".moveNext-mt");
document.addEventListener("DOMContentLoaded", function() {
    $12fa022bfe3847c5$var$initializeSlider("body.ltr #directors-slider", $12fa022bfe3847c5$var$prevArrow, $12fa022bfe3847c5$var$nextArrow);
    $12fa022bfe3847c5$var$initializeSlider("body.rtl #directors-slider", $12fa022bfe3847c5$var$nextArrow, $12fa022bfe3847c5$var$prevArrow, true);
    $12fa022bfe3847c5$var$initializeSlider("body.ltr #management-slider", $12fa022bfe3847c5$var$prevArrowMt, $12fa022bfe3847c5$var$nextArrowMt);
    $12fa022bfe3847c5$var$initializeSlider("body.rtl #management-slider", $12fa022bfe3847c5$var$nextArrowMt, $12fa022bfe3847c5$var$prevArrowMt, true);
});

})();
//# sourceMappingURL=ar.53976a77.js.map
